import { type RefObject, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import styles from 'widgets/CallPopUp/ui/styles.module.scss'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { Head } from 'widgets/CallPopUp/ui/components/Head/Head'
import { BaseContent } from 'widgets/CallPopUp/ui/components/BaseContent/BaseContent'

type ICallPowerDialerBaseContentProps = {
  refWrap: RefObject<HTMLDivElement>
}

export const CallPowerDialerBaseContent: FC<ICallPowerDialerBaseContentProps> = observer(
  ({ refWrap }) => {
    const { callPopUpPowerDialerStoreV2, innerRefTooltipCurrent } = useCallPopUpDefaultContext()
    const {
      contactInCallDelay,
      fetchedContacts,
      isPause,
      callDelayValue,
      handleSkipContact,
      handleCall,
      handleCallLater,
      isPowerDialerCallingDisabled,
      isPreCallSetupInProgress,
      callFromTeam,
      callFromNumber,
      callFromSmartOption,
      isShowQuietHoursContent,
    } = callPopUpPowerDialerStoreV2

    const contactToDisplay =
      contactInCallDelay ?? (!isPause && isShowQuietHoursContent ? fetchedContacts[0] : null)
    if (!contactToDisplay) return null

    return (
      <div className={styles.section}>
        <div ref={refWrap} className={styles.tooltipWrap} />

        <Head
          isIncoming={false}
          wrapElement={innerRefTooltipCurrent}
          name={callFromTeam?.name}
          phone={callFromNumber?.formatted_number ?? callFromSmartOption}
        />

        <BaseContent
          withPadding={true}
          avatarsInfo={[contactToDisplay.avatarProps.info]}
          name={contactToDisplay.name || contactToDisplay.number}
          number={contactToDisplay.number}
          desc={contactToDisplay.number}
          actionsBottom={
            <div className={styles.powerDialerActions}>
              {isShowQuietHoursContent ? (
                <Button
                  contained={'secondary'}
                  text={'Call later'}
                  onClick={() => handleCallLater(contactToDisplay)}
                />
              ) : (
                <Typography
                  className={styles.powerDialerActions__label}
                  variant={'body-md-medium'}
                  ariaLabel={'Next call'}
                >
                  Next call in {callDelayValue} sec...
                </Typography>
              )}
              <div className={styles.powerDialerActions__buttons}>
                <Button
                  contained={'secondary'}
                  text={'Skip'}
                  onClick={() => handleSkipContact(contactToDisplay)}
                  disabled={isPowerDialerCallingDisabled}
                />
                <Button
                  intent={'positive'}
                  contained={'primary'}
                  icon={'phone'}
                  text={'Call'}
                  loading={isPreCallSetupInProgress}
                  onClick={() => handleCall(contactToDisplay.id)}
                  disabled={isPowerDialerCallingDisabled}
                />
              </div>
            </div>
          }
        />
      </div>
    )
  }
)
